<template>
  <ListView
    modelName="SalesDeliveryItem"
    :perm="isInvoiceItem? 'sales.menu_invoice_item':'sales.menu_sales_delivery_item'"        
    :svg="isInvoiceItem? 'icon_side_request_list' : 'icon_side_shipment_list'" 
    color="steelblue"
    :items.sync="items"
    :params.sync="params"
    :title="isInvoiceItem ? 'menu_invoice_item' : 'menu_sales_delivery_item'"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="SalesDeliveryItem"
    :gridCaptions="listCaptions"
    :gridWidths="listWidths"
    :onCreate="onCreate"
    :importQuery="isInvoiceItem ? null : importQuery"
    :exportQuery="isInvoiceItem ? invoiceExportQuery : exportQuery"
    class="sales_delivery_item"
    borderColor="#E35F71"
    backColor="#FFF1F3"        
    tourId="291640"
    :comparer="(a,b)=>a.id == b.id"        
    :popup="popup"    
    :checkStateObject="(a)=>a.delivery"
  >
    <!-- 明細項目の配置 -->
    <GridItem :slot="listSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="salesDeliveryInvoiceItemStatus"/></GridItem>
    <GridItem :slot="listSlots[1]" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.deliveryItemNo }}</GridItem>
    <!-- <GridItem :slot="listSlots[2]" slot-scope="{ item }">{{ item.scheduleDeliveryDate | date }}</GridItem> -->
    <GridItem :slot="listSlots[2]" slot-scope="{ item }">{{ item.deliveryDate | date }}</GridItem>

    <!-- <GridItem :slot="listSlots[3]" slot-scope="{ item }">{{ (item.delivery ? item.delivery.deliveryDate : null) | date }}</GridItem> -->
    <GridItem :slot="listSlots[3]" slot-scope="{ item }">{{ item.delivery?item.delivery.counterpart.name:item.orderItem?item.orderItem.order.counterpart.name:'' }}</GridItem>
    <GridItem :slot="listSlots[4]" slot-scope="{ item }">{{ item.commodity.name }}</GridItem>
    <GridItem :slot="listSlots[5]" slot-scope="{ item }">{{ item.sku == null ? "" : item.sku.name }}</GridItem>
    <GridItem :slot="listSlots[6]" slot-scope="{ item }">{{ item.uom == null ? item.commodity.uom : item.uom.name }}</GridItem>
    <GridItem :slot="listSlots[7]" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale) }}</GridItem>
    <GridItem :slot="listSlots[8]" slot-scope="{ item }">{{ item.deliveryFlag | deliveryFlags }}</GridItem>
    <GridItem :slot="listSlots[9]" slot-scope="{ item }">{{ item.warehouse?item.warehouse.name:'' }}</GridItem>    
    <GridItem :slot="listSlots[10]" slot-scope="{ item }">{{ item.deliveryNo }}</GridItem>
    <!-- <GridItem :slot="listSlots[11]" slot-scope="{ item }">{{ (item.delivery ? item.delivery.deliveryDate : null) | date }}</GridItem> -->
    <GridItem :slot="listSlots[11]" slot-scope="{ item }">{{ item.invoiceNo }}</GridItem>
    <GridItem :slot="listSlots[12]" slot-scope="{ item }">{{ item.bookDate | date }}</GridItem>    
    <GridItem :slot="listSlots[13]" slot-scope="{ item }">{{ item.orderItem ? item.orderItem.order.currencyCode : item.delivery.currencyCode | currency }}</GridItem>        
    <GridItem :slot="listSlots[14]" slot-scope="{ item }" :right="true">{{ item.unitPrice | numeric}}</GridItem>
    <GridItem :slot="listSlots[15]" slot-scope="{ item }">{{ item.taxCode | taxCode }}</GridItem>
    <GridItem :slot="listSlots[16]" slot-scope="{ item }">{{ item.deliveryNo }}</GridItem>    
    <GridItem :slot="listSlots[17]" slot-scope="{ item }">{{ item.orderItem ? item.orderItem.orderItemNo : "" }}</GridItem>
    <GridItem :slot="listSlots[18]" slot-scope="{ item }">{{ item.specificPurchaseItemNo }}</GridItem>
    <!-- <GridItem :slot="listSlots[17]" slot-scope="{ item }">{{ item.seqNo }}</GridItem> -->
    <GridItem :slot="listSlots[19]" slot-scope="{ item }">{{ item.projectItem?item.projectItem.name:''}}</GridItem>      
    <GridItem :slot="listSlots[20]" slot-scope="{ item }">{{ item.segmentId | segment }}</GridItem>
    <GridItem :slot="listSlots[21]" slot-scope="{ item }">{{ item.pic | userGroup }}</GridItem>
    <GridItem :slot="listSlots[22]" slot-scope="{ item }">{{ item.commodityName }}</GridItem>
    <GridItem :slot="listSlots[23]" slot-scope="{ item }" :right="true">{{ item.adjustmentQuantity | numeric(item.commodity.quantityScale) }}</GridItem>
    <GridItem :slot="listSlots[24]" slot-scope="{ item }">{{ item.isNCV | isTarget }}</GridItem>
    <GridItem :slot="listSlots[25]" slot-scope="{ item }">{{ item.commodity.isNoStock | isNoStock }}</GridItem>
    <GridItem :slot="listSlots[26]" slot-scope="{ item }" :right="true">{{ item.dealAmountFC | amountFC(item.orderItem ? item.orderItem.order.currencyCode : item.delivery.currencyCode) }}</GridItem>
    <GridItem :slot="listSlots[27]" slot-scope="{ item }" :right="true">{{ item.amountFC | amountFC(item.orderItem ? item.orderItem.order.currencyCode : item.delivery.currencyCode)  }}</GridItem>
    <GridItem :slot="listSlots[28]" slot-scope="{ item }" :right="true">{{ item.amount | amount  }}</GridItem>
    <!-- <GridItem :slot="listSlots[27]" slot-scope="{ item }">{{ item.description }}</GridItem> -->
    <GridItem :slot="listSlots[29]" slot-scope="{ item }">{{ item.orderItem ? item.orderItem.order.refNo : "" }}</GridItem>
    <GridItem :slot="listSlots[30]" slot-scope="{ item }">{{ item.delivery ? item.delivery.refNo : "" }}</GridItem>
    <GridItem :slot="listSlots[31]" slot-scope="{ item }">{{ item.orderItem ? item.orderItem.order.customerOrderNo : "" }}</GridItem>
    <!-- <GridItem :slot="listSlots[30]" slot-scope="{ item, index }"><Workflow :item="item" :index="index" @updated="onWorkflow"/></GridItem> -->
    <GridItem :slot="listSlots[32]" slot-scope="{ item }">{{ item.initialSavedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[33]" slot-scope="{ item }">{{ item.initialSavedBy | user }}</GridItem>
    <GridItem :slot="listSlots[34]" slot-scope="{ item }">{{ item.lastUpdatedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[35]" slot-scope="{ item }">{{ item.lastUpdatedBy | user  }}</GridItem>

    <!-- 予備項目 -->
    <GridItem :slot="listSlots[36]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText1 == usedTypes.CommodityMemo ? item.commodity.reserveText1 : item.reserveText1)}}</GridItem>
    <GridItem :slot="listSlots[37]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText2 == usedTypes.CommodityMemo ? item.commodity.reserveText2 : item.reserveText2)}}</GridItem>
    <GridItem :slot="listSlots[38]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText3 == usedTypes.CommodityMemo ? item.commodity.reserveText3 : item.reserveText3)}}</GridItem>
    <GridItem :slot="listSlots[39]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText4 == usedTypes.CommodityMemo ? item.commodity.reserveText4 : item.reserveText4)}}</GridItem>
    <GridItem :slot="listSlots[40]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText5 == usedTypes.CommodityMemo ? item.commodity.reserveText5 : item.reserveText5)}}</GridItem>
    <GridItem :slot="listSlots[41]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText6 == usedTypes.CommodityMemo ? item.commodity.reserveText6 : item.reserveText6)}}</GridItem>
    <GridItem :slot="listSlots[42]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo1 == usedTypes.CommodityMemo ? item.commodity.reserveMemo1 : item.reserveMemo1)}}</GridItem>
    <GridItem :slot="listSlots[43]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo2 == usedTypes.CommodityMemo ? item.commodity.reserveMemo2 : item.reserveMemo2)}}</GridItem>
    <GridItem :slot="listSlots[44]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo3 == usedTypes.CommodityMemo ? item.commodity.reserveMemo3 : item.reserveMemo3)}}</GridItem>
    <GridItem :slot="listSlots[45]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate1 == usedTypes.CommodityMemo ? item.commodity.reserveDate1 : item.reserveDate1) | date}}</GridItem>
    <GridItem :slot="listSlots[46]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate2 == usedTypes.CommodityMemo ? item.commodity.reserveDate2 : item.reserveDate2) | date}}</GridItem>
    <GridItem :slot="listSlots[47]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate3 == usedTypes.CommodityMemo ? item.commodity.reserveDate3 : item.reserveDate3)| date}}</GridItem>
    <GridItem :slot="listSlots[48]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList1 == usedTypes.CommodityMemo ? item.commodity.reserveList1 : item.reserveList1 ) | category_41}}</GridItem>
    <GridItem :slot="listSlots[49]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList2 == usedTypes.CommodityMemo ? item.commodity.reserveList2 : item.reserveList2 ) | category_42}}</GridItem>
    <GridItem :slot="listSlots[50]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList3 == usedTypes.CommodityMemo ? item.commodity.reserveList3 : item.reserveList3 ) | category_43}}</GridItem>

    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }">
      <ListViewMenuBar :listView="listView" :edit="!isInvoiceItem" :add="false" :del="!isInvoiceItem" :copy="!isInvoiceItem" >
        <ListViewMenu v-if="!isInvoiceItem" title="出荷指示" @click="showShippingInstructionDialog" :tooltip="tooltipValue.button.shippingInstruction" />
        <ListViewMenu v-if="isInvoiceItem" title="請求処理" @click="showBookSalesDialog" :tooltip="tooltipValue.button.bookSales" />
        <ListViewMenu v-if="isInvoiceItem" title="一括請求処理" @click="showBulkBookSalesDialog" :tooltip="tooltipValue.button.bulkBookSales" />
        <ListViewMenu v-if="isInvoiceItem" title="請求取消" @click="showCancelBookSalesDialog" :tooltip="tooltipValue.button.cancelBookSales" />
        <!-- 返品処理を出荷明細一覧から請求明細一覧に移動 -->
        <ListViewMenu v-if="isInvoiceItem" title="返品処理" @click="showReturnDeliveryDialog" :tooltip="tooltipValue.button.returnDelivery" /> 
        <ListViewMenu v-if="isInvoiceItem==false && $api.useStockFunction" title="諸掛按分処理" @click="showChargeAllocationDialog" :tooltip="tooltipValue.button.chargeAllocation"/>               
      </ListViewMenuBar>
    </template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView"  :tabs="searchTabs" :favoriteVisible="!popup">
        <FilterBox title="請求書番号" :value.sync="params.invoiceNo" @click="handler" v-if="isInvoiceItem"/>        
        <FilterBox title="出荷番号" :value.sync="params.deliveryNo" @click="handler" />
        <FilterBox title="出荷明細番号" :value.sync="params.deliveryItemNo" @click="handler" />        
        <FilterBox title="受注番号" :value.sync="params.orderNo" @click="handler" />
        <FilterBox title="受注明細番号" :value.sync="params.orderItemNo" @click="handler" />
        <FilterBox title="入荷明細番号" :value.sync="params.purchaseDeliveryItemNo" @click="handler" v-if="isInvoiceItem==false"/>
        <FilterBox title="受注管理番号" :value.sync="params.refNo" @click="handler" />
        <FilterBox title="出荷管理番号" :value.sync="params.deliveryRefNo" @click="handler" />
        <FilterBox title="顧客注文番号" :value.sync="params.customerOrderNo" @click="handler" />
        <FilterBox title="納入先名称" :value.sync="params.receiverName" @click="handler" v-if="isInvoiceItem==false" />
        <FilterBox title="商品名称" :value.sync="params.commodityName" @click="handler" />
        <FilterBox title="SKU名称" :value.sync="params.skuName" @click="handler" v-if="isInvoiceItem==false" />
        <FilterBox title="備考" :value.sync="params.description" @click="handler" />
        <AtcCounterpart title="得意先" :value.sync="params.counterpart" :needsCustomer="true" @changed="handler" />
        <AtcCounterpart title="倉庫" :value.sync="params.warehouse" :needsWarehouse="true" @changed="handler" v-if="isInvoiceItem==false"/>
        <AtcSegment title="部門" :value.sync="params.segment" @changed="handler" />        
        <AutoComplete title="担当者" :value.sync="params.pic" list="user" @changed="handler" />
        <AutoComplete title="取引通貨"  :value.sync="params.currencyCode" list="currency" @changed="handler" v-if="hasLicenseCurrency" />                
        <AtcCommodity title="商品" :value.sync="params.commodity" @changed="handler" />
        <AtcSKU title="SKU" :value.sync="params.sku" :commodity="params.commodity" @update:value="handler" />                
        <!-- <Calendar title="出荷予定日(From)" :value.sync="params.scheduledDeliveryDateFrom" :deletable="true" @changed="handler" v-if="isInvoiceItem == false"/> -->
        <!-- <Calendar title="出荷予定日(To)" :value.sync="params.scheduledDeliveryDateTo" :deletable="true" @changed="handler" v-if="isInvoiceItem == false"/> -->
        <Calendar title="出荷日(From)" :value.sync="params.deliveryDateFrom" :deletable="true" @changed="handler" />
        <Calendar title="出荷日(To)" :value.sync="params.deliveryDateTo" :deletable="true" @changed="handler" />
        <Calendar title="売上日(From)" :value.sync="params.bookDateFrom" :deletable="true" @changed="handler" v-if="isInvoiceItem"/>
        <Calendar title="売上日(To)" :value.sync="params.bookDateTo" :deletable="true" @changed="handler" v-if="isInvoiceItem"/>        
        <Calendar title="初回保存日(From)" :value.sync="params.initialSavedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(To)" :value.sync="params.initialSavedOnTo" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(From)" :value.sync="params.lastUpdatedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(To)" :value.sync="params.lastUpdatedOnTo" :deletable="true" @changed="handler" />
        <AutoComplete title="所有者" :value.sync="params.holder" list="user" @changed="handler" />         
        <ComboBox title="状態" :value.sync="params.state" list="salesDeliveryItemStatus" @changed="handler" :showDefault="false"  v-if="isInvoiceItem == false"/>
        <ComboBox title="状態" :value.sync="params.state" list="invoiceItemStatus" @changed="handler" :showDefault="false" v-if="isInvoiceItem"/>
        <!-- <ComboBox title="所有者" :value.sync="params.holder" list="user" @changed="handler" /> -->

        <FilterBox slot="tab1" title="reserve_text1" :value.sync="params.reserveText1" @click="handler"   v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText1)" />
        <FilterBox slot="tab1" title="reserve_text2" :value.sync="params.reserveText2" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText2)"/>
        <FilterBox slot="tab1" title="reserve_text3" :value.sync="params.reserveText3" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText3)"/>
        <FilterBox slot="tab1" title="reserve_text4" :value.sync="params.reserveText4" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText4)"/>
        <FilterBox slot="tab1" title="reserve_text5" :value.sync="params.reserveText5" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText5)"/>
        <FilterBox slot="tab1" title="reserve_text6" :value.sync="params.reserveText6" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText6)"/>
        <FilterBox slot="tab1" title="reserve_memo1" :value.sync="params.reserveMemo1" @click="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveMemo1)"/>
        <FilterBox slot="tab1" title="reserve_memo2" :value.sync="params.reserveMemo2" @click="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveMemo2)"/>
        <FilterBox slot="tab1" title="reserve_memo3" :value.sync="params.reserveMemo3" @click="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveMemo3)"/>
        <Calendar slot="tab1" title="reserve_date1|(From)" :value.sync="params.reserveDate1From" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate1)"/>
        <Calendar slot="tab1" title="reserve_date1|(To)" :value.sync="params.reserveDate1To" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate1)"/>
        <Calendar slot="tab1" title="reserve_date2|(From)" :value.sync="params.reserveDate2From" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate2)"/>
        <Calendar slot="tab1" title="reserve_date2|(To)" :value.sync="params.reserveDate2To" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate2)"/>
        <Calendar slot="tab1" title="reserve_date3|(From)" :value.sync="params.reserveDate3From" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate3)"/>
        <Calendar slot="tab1" title="reserve_date3|(To)" :value.sync="params.reserveDate3To" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate3)"/>
        <ComboBox slot="tab1" title="reserve_list1" :value.sync="params.reserveList1" list="category_41" @changed="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveList1)"/>
        <ComboBox slot="tab1" title="reserve_list2" :value.sync="params.reserveList2" list="category_42" @changed="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveList2)"/>
        <ComboBox slot="tab1" title="reserve_list3" :value.sync="params.reserveList3" list="category_43" @changed="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveList3)"/>                
      </Search>
    </template>
    <!-- フルサイズエディタの配置(ListView:fullSizeEditor="true"を指定) -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報','その他情報','売上諸掛按分明細','納入先詳細','予備項目','更新履歴']" :tabVisibles="tabVisibles" 
        :tabTooltips="
          isInvoiceItem
            ? [null, null, '選択した【請求明細】に紐づいている【出荷明細】で登録された【売上諸掛按分明細】が表示されます。', null, '選択した【請求明細】に紐づく【出荷明細】の予備項目タブの内容が表示されます。内容は帳票に載せることができます。', null]
            : [null,null,'選択した【出荷明細】に紐づいている【売上諸掛按分明細】を確認できます。','【納入先】の情報が表示されます。【出荷明細一覧】からは変更できません。','商品単位で任意にテキスト入力・区分の設定・日付設定を行えます｡項目名は【テナント設定】＞【商品予備項目】から変更が可能です。',null]"
      >
        <!-- エディタ編集・機能ボタン -->
        <template slot="menu" slot-scope="{ item,editor}">
          <Button class="button" @click="showDirectAccessDialg(item)" caption="関連伝票"  icon="account_tree" tooltip="関連する伝票へのリンクを表示します。"/>      
        </template>
        <!-- 基本情報タブ -->
        <template slot="tab0" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">
              <!-- <TextBox title="明細番号" :value="item.deliveryItemNo" :editor="editor" :enabled="false" />      -->
              <RowSequence title="明細番号" :value="item.seqNo" :displayValue="item.deliveryItemNo" :item="item" :editor="editor"  :perm="$refs.mainList.perm+'.edit'"  :enabled="isEditable(item, false, false, true, false) && !!item.deliveryNo" :tooltip="tooltipValue.field.deliveryItemNo" :buttonTooltip="tooltipValue.button.updateSeq"/>                       
              <!-- <TextBox title="明細ID" :value="item.id" :editor="editor" :enabled="false" /> -->
              <!-- <div @click="showSalesOrderItem(item.orderItem ? item.orderItem.orderItemNo : '', editor)" :class="editor.isEdit ? '' : 'cx_link'">
                <TextBox title="受注明細番号" :value="item.orderItem ? item.orderItem.orderItemNo : ''" :editor="editor" :enabled="false" />
              </div> -->
              <!-- <Calendar title="出荷予定日" :value.sync="item.scheduleDeliveryDate" :editor="editor" :required="true" :enabled="isEditableStock(item)" v-if="isInvoiceItem == false"/> -->
              <!-- <Calendar title="出荷日" :value="item.delivery ? item.delivery.deliveryDate : null" :editor="editor" :enabled="false" v-if="isInvoiceItem"/> -->
              <Calendar title="出荷日" :value.sync="item.deliveryDate" :editor="editor" :enabled="isEditableStockDeliveryDate(item)" :tooltip="tooltipValue.field.deliveryDate" />

              <!-- order.counterpartとdelivery.counterpartのどちらかしかロードされないのでリンクに変換できない -->
              <AtcCounterpart title="得意先" :value="item.delivery.counterpart" :needsCustomer="true" :editor="editor"  :enabled="false" v-if="item.delivery" :tooltip="tooltipValue.field.counterpart" />                 
              <AtcCounterpart title="得意先" :value="item.orderItem.order.counterpart" :needsCustomer="true" :editor="editor"  :enabled="false" v-if="! item.delivery" :tooltip="tooltipValue.field.counterpart" />   
              <TextBox title="納入区分" :value="item.deliveryFlag | deliveryFlags" :editor="editor" :enabled="false" v-if="isInvoiceItem == false" :tooltip="tooltipValue.field.deliveryFlag" />              
              <AtcCounterpart title="出庫倉庫" :value="item.warehouse" :needsWarehouse="true"  :editor="editor"  :enabled="false" v-if="isInvoiceItem == false"  :tooltip="tooltipValue.field.warehouse" />                 
              <AtcCommodity title="商品" :value.sync="item.commodity" :editor="editor" :required="true" :enabled="isEditableResult(item)" @update:value="onChangeCommodity(item)" :tooltip="tooltipValue.field.commodity" />
              <AtcSKU title="SKU" :value.sync="item.sku" :editor="editor" :commodity="item.commodity" :enabled="isEditableResult(item)"  :tooltip="tooltipValue.field.sku" />              
              <AtcConversion title="単位" :value.sync="item.uom2" :editor="editor" :required="true" :enabled="isEditableResult(item)" :commodity="item.commodity" :tooltip="tooltipValue.field.uom" />
              <NumericBox title="出荷数量" :value.sync="item.quantity" :editor="editor" :required="true" :enabled="isEditableStock(item)" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" min="-99999999.999" max="99999999.999" :nullValue="0" :isDirectEditEnabled="false" :tooltip="tooltipValue.field.quantity" />                                    
            </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">              
              <TextBox title="出荷番号" :value="item.deliveryNo" :editor="editor" :enabled="false" linkFormat="/sales/SalesDelivery?deliveryNo={0}" v-if="isInvoiceItem == false" :tooltip="tooltipValue.field.deliveryNo" />       
              <!-- <Calendar title="出荷日" :value="item.delivery ? item.delivery.deliveryDate : null" :editor="editor" :enabled="false" v-if="isInvoiceItem == false"/>                      -->
              <TextBox title="請求書番号" :value="item.invoiceNo" :editor="editor" :enabled="false" :linkFormat="getInvoiceLinkFormat(item)" v-if="isInvoiceItem" :tooltip="tooltipValue.field.invoiceNo"/>
              <Calendar title="売上日" :value="item.bookDate " :editor="editor" :enabled="false" v-if="isInvoiceItem" :tooltip="tooltipValue.field.bookDate" />                       
              <TextBox title="取引通貨" :value="(item.delivery ?  item.delivery.currencyCode : item.orderItem.order.currencyCode) | currency"  :enabled="false" v-if="hasLicenseCurrency"/>                         
              <div class="cx_controls">
                <NumericBox title="単価" :value.sync="item.unitPrice" :editor="editor" :required="false" :enabled="isPriceEditable(item)" min="-999999999.999999" max="999999999.999999" :nullValue="0" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" :tooltip="tooltipValue.field.unitPrice"/>
                <Button class="button cx_itembutton" style="margin-left:10px" @click="getPriceAndTaxCode(item)" caption="単価取得" :disabled="!editor.isEdit || !isPriceEditable(item)" :tooltip="tooltipValue.button.getPrice"/>
              </div>
              <AtcTaxCode title="税区分" :value.sync="item.taxCode" :editor="editor" list="taxCode" :required="true" :enabled="isPriceEditable(item)" :tooltip="tooltipValue.field.taxCode"/>
              <TextBox title="出荷番号" :value="item.deliveryNo" :editor="editor" :enabled="false" linkFormat="/sales/SalesDelivery?deliveryNo={0}" v-if="isInvoiceItem"  :tooltip="tooltipValue.field.deliveryNo"/>              
              <TextBox title="受注明細番号" :value="item.orderItem ? item.orderItem.orderItemNo : ''" :editor="editor" :enabled="false" linkFormat="/sales/SalesOrderItem?orderItemNo={0}" :tooltip="tooltipValue.field.orderItemNo"/>                            
              <!-- <div @click="showPurchaseDeliveryItem(item.specificPurchaseItemNo, editor)" :class="editor.isEdit ? '' : 'cx_link'">
                <TextBox title="入荷明細番号" :value="item.specificPurchaseItemNo" :editor="editor" :enabled="isEditable(item, false, false, false, true)" />
              </div> -->
              <TextBox title="入荷明細番号" :value="item.specificPurchaseItemNo" :editor="editor" :enabled="isEditableSpecificPricing(item)" :required="isEditableSpecificPricing(item)" linkFormat="/purchase/PurchaseDeliveryItem?deliveryItemNo={0}" v-if="isInvoiceItem==false" :tooltip="tooltipValue.field.purchaseDeliveryItemNo"/>                            
              <TextBox title="最終更新日" :value="$api.perms.getLastUpdateLabel(item)" :enabled="false"   :tooltip="tooltipValue.field.lastUpdateTime" />              
              <TextBox title="状態" :value="$api.perms.getStateLabel(item,'salesDeliveryInvoiceItemStatus')" :enabled="false" :tooltip="tooltipValue.field.state" />                     
            </template>
          </EditPanel>
        </template>
        <!-- その他情報タブ -->
        <template slot="tab1" slot-scope="{ item,editor}">
          <EditPanel>
            <!-- その他情報タブ 左側 -->
            <template slot="left">
              <!-- <TextBox title="部門" :value="item.segmentId | segment" :enabled="false" /> -->
              <AtcSegment title="部門" :value.sync="item.segment" :enabled="false" :tooltip="tooltipValue.field.segment" />              
              <AutoComplete title="担当者" :value.sync="item.pic"  list="user"  :enabled="false" :tooltip="tooltipValue.field.pic" />               
              <TextBox title="商品名称" :value.sync="item.commodityName" :editor="editor" :required="true" :enabled="isEditableResult(item)" length="100" :tooltip="tooltipValue.field.commodityName"/>
              <NumericBox title="調整数量" :value.sync="item.adjustmentQuantity" :editor="editor" :enabled="isEditableStock(item)" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" min="-99999999.999" max="99999999.999" :isDirectEditEnabled="false" :nullValue="0" v-if="isInvoiceItem == false" :tooltip="tooltipValue.field.adjustmentQuantity" />                            
              <CheckBox title="NCV" :value.sync="item.isNCV" :editor="editor" list="isTarget" :enabled="isEditableResult(item)" v-if="hasLicenseCurrency" />              
              <TextBox title="棚卸対象外" :value="(item.commodity != null ? item.commodity.isNoStock : false) | isNoStock" :editor="editor" :enabled="false" v-if="isInvoiceItem == false" :tooltip="tooltipValue.field.noStockFlag" />
              <TextBox title="取引金額" :value="$api.formatter.formatAmountFC(item.dealAmountFC,item.delivery ? item.delivery.currencyCode : item.orderItem.order.currencyCode)" :enabled="false"  :nullValue="0" :tooltip="tooltipValue.field.dealAmountFC" />
              <TextBox title="税抜金額" :value="$api.formatter.formatAmountFC(item.amountFC,item.delivery ? item.delivery.currencyCode : item.orderItem.order.currencyCode)" :enabled="false"  :nullValue="0" v-if="isInvoiceItem"  :tooltip="tooltipValue.field.amountFC" />
              <TextBox title="計上金額" :value="$api.formatter.formatAmount(item.amount)" :enabled="false"  :nullValue="0"  v-if="hasLicenseCurrency && isInvoiceItem"/>
           
            </template>
            <!-- その他情報タブ 右側 -->
            <template slot="right">                  
              <TextBox title="受注管理番号" :value="item.orderItem ? item.orderItem.order.refNo : ''" :enabled="false" :tooltip="tooltipValue.field.refNo"/>
              <TextBox title="出荷管理番号" :value="item.delivery ? item.delivery.refNo : ''" :enabled="false" :tooltip="tooltipValue.field.deliveryRefNo"/>
              <TextBox title="顧客注文番号" :value="item.orderItem ? item.orderItem.order.customerOrderNo : ''" :enabled="false" :tooltip="tooltipValue.field.customerOrderNo"/>
              <TextBox title="一式表記" :value.sync="item.groupingName"  :editor="editor" :enabled="true" length="25" tooltip="一式表記を指定すると、対外帳票で一式表記(集計行)が行えます。"/>                   
              <TextBox title="備考" :value.sync="item.description" :editor="editor" :enabled="isEditable(item, false, false, true, false)" length="200" rows="7" :tooltip="tooltipValue.field.description"/>   
            </template>
          </EditPanel>
        </template>           
        <!-- 売上諸掛按分明細タブ -->
        <template slot="tab2" slot-scope="{ item}">
          <GrdVoucherItem :voucherNo="item.id" :voucherType="voucherTypes.SalesDeliveryItem" :voucherItemType="voucherTypes.SalesChargeItem" />
        </template>               
        <!-- 納入先詳細タブ -->
        <template slot="tab3" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 納入先詳細タブ 左側 -->
            <template slot="left">
              <TextBox title="納入先名称" :editor="editor" :value="item.delivery ? item.delivery.outputReceiverName : item.orderItem ? item.orderItem.order.outputReceiverName :''" :enabled="false" length="50" />
              <TextBox title="担当部署名" :editor="editor" :value="item.delivery ? item.delivery.outputReceiverPICSection : item.orderItem ? item.orderItem.order.outputReceiverPICSection :  ''" :enabled="false" length="50" />
              <TextBox title="担当者" :editor="editor" :value="item.delivery ? item.delivery.outputReceiverPIC : item.orderItem ? item.orderItem.order.outputReceiverPIC :  ''" :enabled="false" length="30" />
              <TextBox title="敬称" :editor="editor" :value="item.delivery ? item.delivery.outputReceiverPICHonorificTitle : item.orderItem ? item.orderItem.order.outputReceiverPICHonorificTitle :  ''" :enabled="false" length="5" />
              <TextBox title="電話番号" :editor="editor" :value="item.delivery ? item.delivery.outputReceiverTelNo : item.orderItem ? item.orderItem.order.outputReceiverTelNo :  ''" :enabled="false" length="20" />
              <TextBox title="FAX番号" :editor="editor" :value="item.delivery ? item.delivery.outputReceiverFaxNo : item.orderItem ? item.orderItem.order.outputReceiverFaxNo :  ''" :enabled="false" length="20" />              
            </template>
            <!-- 納入先詳細タブ 右側 -->
            <template slot="right">
              <TextBox title="郵便番号" :editor="editor" :value="item.delivery ? item.delivery.outputReceiverPostalCode : item.orderItem ? item.orderItem.order.outputReceiverPostalCode :  ''" :enabled="false" length="50" />
              <TextBox title="住所1" :editor="editor" :value="item.delivery ? item.delivery.outputReceiverAddress1 : item.orderItem ? item.orderItem.order.outputReceiverAddress1 :  ''" :enabled="false" length="50" />
              <TextBox title="住所2" :editor="editor" :value="item.delivery ? item.delivery.outputReceiverAddress2 : item.orderItem ? item.orderItem.order.outputReceiverAddress2 : ''" :enabled="false" length="50" />
              <TextBox title="住所3" :editor="editor" :value="item.delivery ? item.delivery.outputReceiverAddress3 : item.orderItem ? item.orderItem.order.outputReceiverAddress3 :  ''" :enabled="false" length="50" />              
            </template>
          </EditPanel>
        </template>                   
        <!-- 予備項目タブ -->
        <template slot="tab4" slot-scope="{ item, editor }">
          <PnlReserveItems :item="item" :editor="editor" :enabled="isEditable(item, false, false, true, false)" :commodityAttribute="visibleTypes.Editable" :stockAttribute="visibleTypes.Editable"  :orderMemo="visibleTypes.ReadOnly" :deliveryMemo="visibleTypes.Editable" :inheritCommodityAttributeInvalid="true" :commodity="item.commodity" /> 
        </template>

        <!-- 更新履歴タブ -->
        <template slot="tab5" slot-scope="{ item }">
          <AuditLog :auditName="item.auditName" :auditNo="item.auditNo" />
        </template>
      </Editor>
    </template>
    <template slot="modal" slot-scope="{ listView }">          
      <!-- 出荷指示ダイアログ -->
      <ListDialog ref="shippingInstructionDialog" title="出荷指示" :buttonNames="siButtonNames" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :execWithIndex="submitShippingInstruction" >
        <!-- 出荷指示ダイアログ ヘッダ項目 -->
        <template slot="header" slot-scope="{ editor }">
          <EditPanel>
            <!-- 出荷指示ダイアログ ヘッダ項目 左側 -->
            <template slot="left">
              <ComboBox title="ワークフロー" :value.sync="siWorkflowId" :editor="editor" :required="siWorkflowRequired" :enabled="siWorkflowRequired" list="workflow_salesDelivery" :nullValue="0" @changed="onChangeWorkflowShippingInstruction()" :tooltip="tooltipValue.dialog.shippingInstruction.workflowId" />
              <AutoComplete title="担当" :value.sync="siPic" :editor="editor" :required="true" list="user" :tooltip="tooltipValue.dialog.shippingInstruction.pic"/>
              <TextBox title="出荷管理番号" :value.sync="siRefNo" :editor="editor" length="30" :tooltip="tooltipValue.dialog.shippingInstruction.deliveryRefNo"/>
              <Calendar title="出荷日" :value.sync="siDeliveryDate" :editor="editor" />
              <AtcCounterpart title="納入先" :value.sync="siReceiver" :editor="editor" :needsCustomer="true" :needsReceiver="true" :customer="siCounterpart" @update:value="onChangeSiReceiver()" />
              <TextBox title="納入先名称" :value.sync="siReceiverName" :editor="editor" length="50" :tooltip="tooltipValue.dialog.shippingInstruction.outputReceiverName"/>
              <TextBox title="担当部署名" :value.sync="siReceiverPICSection" :editor="editor" length="50" :tooltip="tooltipValue.dialog.shippingInstruction.outputReceiverPICSection"/>
              <TextBox title="担当者" :value.sync="siReceiverPIC" :editor="editor" length="30" />
              <TextBox title="敬称" :value.sync="siReceiverPICHonorificTitle" :editor="editor" length="5" />
            </template>
            <!-- 出荷指示ダイアログ ヘッダ項目 右側 -->
            <template slot="right">
              <TextBox title="郵便番号" :value.sync="siReceiverPostalCode" :editor="editor" length="50" :tooltip="tooltipValue.dialog.shippingInstruction.outputReceiverPostalCode"/>
              <TextBox title="住所1" :value.sync="siReceiverAddress1" :editor="editor" length="50" :tooltip="tooltipValue.dialog.shippingInstruction.outputReceiverAddress1"  />
              <TextBox title="住所2" :value.sync="siReceiverAddress2" :editor="editor" length="50" :tooltip="tooltipValue.dialog.shippingInstruction.outputReceiverAddress2" />
              <TextBox title="住所3" :value.sync="siReceiverAddress3" :editor="editor" length="50" :tooltip="tooltipValue.dialog.shippingInstruction.outputReceiverAddress3" />
              <TextBox title="電話番号" :value.sync="siReceiverTelNo" :editor="editor" length="20" :tooltip="tooltipValue.dialog.shippingInstruction.outputReceiverTelNo"/>
              <TextBox title="FAX番号" :value.sync="siReceiverFaxNo" :editor="editor" length="20" :tooltip="tooltipValue.dialog.shippingInstruction.outputReceiverFaxNo" />
              <TextBox title="出荷指示" :value.sync="siDeliveryInstruction" :editor="editor" length="200" rows="5" :tooltip="tooltipValue.dialog.shippingInstruction.deliveryInstruction" />
            </template>
          </EditPanel>
        </template>
      </ListDialog>
      <!-- 返品処理ダイアログ -->
      <!-- <ListDialog ref="returnDeliveryDialog" title="返品処理" :buttonNames="rdButtonNames" modelName="SalesDeliveryItem" :captions="rdCaptions" :widths="rdWidths" :showAdd="false" :showRemove="false" :execWithIndex="submitReturnDelivery" :height="235" :width="1000">
        <template slot="header" slot-scope="{ editor }">
          <EditPanel>
            <template slot="left">
              <ComboBox title="ワークフロー" :value.sync="rdWorkflowId" :editor="editor" :required="true" :enabled="$api.perms.hasWorkflow('salesDelivery')" list="workflow_salesDelivery" :nullValue="0" @changed="onReturnDeliveryChangeWorkflow()"  :tooltip="tooltipValue.dialog.returnDeliveryDialog.workflowId" />                            
              <ComboBox title="担当者" :value.sync="rdPic" :editor="editor" :required="true" list="user" :tooltip="tooltipValue.dialog.returnDeliveryDialog.pic" />
              <Calendar title="返品日" :value.sync="rdReturnDate" :editor="editor" />
            </template>
          </EditPanel>               
        </template>
        <AtcCommodity :slot="rdSlots[0]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.commodity" :enabled="false" />
        <AtcSKU :slot="rdSlots[1]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.sku" :commodity="item.commodity" :enabled="false" />
        <NumericBox :slot="rdSlots[2]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.quantity" :required="true" more="0" max="99999999.999" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" />
        <NumericBox :slot="rdSlots[3]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.adjustmentQuantity"  min="0" max="99999999.999" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" />

        <TextBox :slot="rdSlots[4]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText1  != usedTypes.CommodityMemo" :value.sync="item.reserveText1" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[4]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText1:''" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[5]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText2  != usedTypes.CommodityMemo" :value.sync="item.reserveText2" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[5]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText2:''" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[6]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText3  != usedTypes.CommodityMemo" :value.sync="item.reserveText3" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[6]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText3:''" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[7]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText4  != usedTypes.CommodityMemo" :value.sync="item.reserveText4" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[7]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText4  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText4:''" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[8]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText5  != usedTypes.CommodityMemo" :value.sync="item.reserveText5" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[8]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText5  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText5:''" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[9]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText6  != usedTypes.CommodityMemo" :value.sync="item.reserveText6" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[9]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText6  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText6:''" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[10]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo1  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo1" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[10]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo1:''" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[11]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo2  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo2" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[11]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo2:''" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[12]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo3  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo3" :editor="editor" :enabled="false" />
        <TextBox :slot="rdSlots[12]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo3:''" :editor="editor" :enabled="false" />
        <Calendar :slot="rdSlots[13]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate1  != usedTypes.CommodityMemo" :value.sync="item.reserveDate1" :editor="editor" :enabled="false" />
        <Calendar :slot="rdSlots[13]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate1: null" :editor="editor" :enabled="false" />
        <Calendar :slot="rdSlots[14]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate2  != usedTypes.CommodityMemo" :value.sync="item.reserveDate2" :editor="editor" :enabled="false" />
        <Calendar :slot="rdSlots[14]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate2: null" :editor="editor" :enabled="false" />
        <Calendar :slot="rdSlots[15]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate3  != usedTypes.CommodityMemo" :value.sync="item.reserveDate3" :editor="editor" :enabled="false" />
        <Calendar :slot="rdSlots[15]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate3: null" :editor="editor" :enabled="false" />
        <AutoComplete :slot="rdSlots[16]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList1  != usedTypes.CommodityMemo" :value.sync="item.reserveList1" :editor="editor" list="category_41" :enabled="false" path="/master/Category" />
        <AutoComplete :slot="rdSlots[16]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList1:''" :editor="editor" list="category_41" :enabled="false" path="/master/Category" />
        <AutoComplete :slot="rdSlots[17]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList2  != usedTypes.CommodityMemo" :value.sync="item.reserveList2" :editor="editor" list="category_42" :enabled="false" path="/master/Category" />
        <AutoComplete :slot="rdSlots[17]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList2:''" :editor="editor" list="category_42" :enabled="false" path="/master/Category" />
        <AutoComplete :slot="rdSlots[18]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList3  != usedTypes.CommodityMemo" :value.sync="item.reserveList3" :editor="editor" list="category_43" :enabled="false" path="/master/Category" />        
        <AutoComplete :slot="rdSlots[18]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList3:''" :editor="editor" list="category_43" :enabled="false" path="/master/Category" />        
      </ListDialog> -->

      <!-- 請求処理ダイアログ -->
      <!-- <ListDialog ref="bookSalesDialog" title="請求処理" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="submitBookSales" >
        <template slot="header" slot-scope="{ editor }">
          <ComboBox title="ワークフロー" :value.sync="bsWorkflowIdAlone" v-if="bsHasAlone" :editor="editor" list="workflow_aloneInvoice" :required="true" :enabled="$api.perms.hasWorkflow('aloneInvoice')" :nullValue="0"  :tooltip="tooltipValue.dialog.bookSalesDialog.workflow_aloneInvoice" />          
          <ComboBox title="ワークフロー" :value.sync="bsWorkflowIdCarryOver" v-if="bsHasCarryOver" :editor="editor" list="workflow_carryOverInvoice" :required="true" :enabled="$api.perms.hasWorkflow('carryOverInvoice')" :nullValue="0"  :tooltip="tooltipValue.dialog.bookSalesDialog.workflow_carryOverInvoice" />          
          <ComboBox title="請求区分" :value.sync="bsInvoiceType" :editor="editor" list="invoiceTypes" :enabled="false" :tooltip="tooltipValue.dialog.bookSalesDialog.invoiceTypes" />
          <CheckBox title="個別請求フラグ" :value.sync="bsSeparateInvoiceFlag" list="isTarget" :editor="editor" :enabled="bsEnabledSeparateInvoiceFlag"  @changed="onBsSeparateInvoiceFlagChange()" :tooltip="tooltipValue.dialog.bookSalesDialog.isTarget" />
          <CheckBox v-if="!bsSeparateInvoiceFlag" title="売上日変更" :value.sync="bsBookDateChangeFlag" list="isChanged" :editor="editor" :enabled="bsEnabledSeparateInvoiceFlag"  @changed="onBsBookDateChangeFlagChange()" :tooltip="tooltipValue.dialog.bookSalesDialog.bookDateChanged" />
          <Calendar title="売上日" :value.sync="bsBookDate" :editor="editor" :required="true" :enabled="bsSeparateInvoiceFlag || bsBookDateChangeFlag" :deletable="false" @changed="onBsBookDateChange()" :tooltip="tooltipValue.dialog.bookSalesDialog.bookDate" />
          <Calendar title="入金予定日" :value.sync="bsDueDate" :editor="editor" :enabled="bsSeparateInvoiceFlag" :deletable="false" :tooltip="tooltipValue.dialog.bookSalesDialog.dueDate" />
          <AutoComplete title="請求口座" :value.sync="bsBankAccount" :editor="editor" query="BankAccountMasterQuery" :required="true" :tooltip="tooltipValue.dialog.bookSalesDialog.bankAccount" />
          <TextBox v-if="!bsCarryOverInvoiceFlag & hasLicenseCurrency" title="取引通貨" :value="bsCurrencyCode | currency" :editor="editor" :enabled="false" />
          <NumericBox v-if="!bsCarryOverInvoiceFlag & hasLicenseCurrency" title="計上レート" :value.sync="bsExchangeRate" :editor="editor" :required="true" min="0.000001" max="999.999999" decimalsInput="6" />
          <TextBox v-if="bsSeparateInvoiceFlag" :enabled="false" />
        </template>
      </ListDialog> -->
      <!-- 請求取消処理ダイアログ -->
      <!-- <ListDialog ref="cancelBookSalesDialog" title="請求取消処理" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="submitCancelBookSales" >
        <template slot="header" slot-scope="{  }">請求取消処理を開始します。</template>
      </ListDialog> -->

      <!--諸掛按分処理ダイアログ -->
      <ListDialog ref="chargeAllocationDialog" title="諸掛按分処理" :buttonNames="caButtonNames" modelName="SalesCharge" :captions="caConfig.gridCaptions" :widths="caConfig.gridWidths"  :execWithIndex="submitChargeAllocation" :height="235" :width="1000">
        <!-- 諸掛按分処理ダイアログ ヘッダ項目 -->
        <template slot="header" slot-scope="{ editor }">
          <EditPanel>
            <template slot="left">
              <ComboBox title="ワークフロー" :value.sync="caWorkflowId" :editor="editor"  list="workflow_charge"  :required="$api.perms.hasWorkflow('charge')" :enabled="$api.perms.hasWorkflow('charge')" :nullValue="0" @changed="onChargeAllocationChangeWorkflow()" :tooltip="tooltipValue.dialog.chargeAllocation.workflowId" />           
              <AutoComplete title="担当者" :value.sync="caPic" :editor="editor" :required="true" list="user" :tooltip="tooltipValue.dialog.chargeAllocation.pic" />
              <Calendar title="発生日" :value.sync="caBookDate" :editor="editor" @update:value="onChangeChargeDate" :tooltip="tooltipValue.dialog.chargeAllocation.chargeDate" />
              <ComboBox title="按分方法" :value.sync="caProportionalDivision" :editor="editor" :list="hasLicenseCurrency?'proportionalDivisionFlags2':'proportionalDivisionFlags2NoLicenseCurrency'" :required="true" :tooltip="tooltipValue.dialog.chargeAllocation.proportionalDivision" />              
              <AutoComplete title="取引通貨" :value.sync="caCurrencyCode" :editor="editor" list="currency" v-if="hasLicenseCurrency" @update:value="onChangeCurrency" :required="true"/>
              <NumericBox title="計上レート" :value.sync="caExchangeRate" v-if="hasLicenseCurrency" :editor="editor" :required="true"/>            
              <TextBox title="諸掛管理番号" :value.sync="caRefNo" :editor="editor" length="30" :tooltip="tooltipValue.dialog.chargeAllocation.chargeRefNo"/>   
            </template>
          </EditPanel>               
        </template>
        <!-- 諸掛按分処理ダイアログ 一覧項目 -->
        <AtcCounterpart :slot="caConfig.gridSlots[0]" slot-scope="{ item, editor }" :value.sync="item.counterpart" :editor="editor" :needsSupplier="true" :needsWarehouse="true" :required="true" @update:value="onChangeCounterpart(item)" />
        <AutoComplete  :slot="caConfig.gridSlots[1]" slot-scope="{ item, editor }" :value.sync="item.account" :editor="editor" query="SalesChargeAccountMasterQuery" :required="true" />
        <NumericBox  :slot="caConfig.gridSlots[2]" slot-scope="{ item, editor }" :value.sync="item.dealAmountFC" :editor="editor" :required="true" :decimals="caDecimal" />
        <AtcTaxCode  :slot="caConfig.gridSlots[3]" slot-scope="{ item, editor }" :value.sync="item.taxCode" :editor="editor" list="taxCode" :required="true"/>
        <Calendar  :slot="caConfig.gridSlots[4]" slot-scope="{ item, editor }" :value.sync="item.dueDate" :editor="editor" :required="true"/>
      </ListDialog>            
    </template>
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class SalesDeliveryItemView extends Vue {
  public bulkBookSales = Components.BulkBookSales;
  public returnDelivery = Components.ReturnDelivery;
  public cancelBookSales = Components.CancelBookSales;
  public bookSales = Components.BookSales;
  public items: Common.SalesDeliveryItem[] = new Array(0);
  public params: Common.DeliveryItemQuery = new Common.DeliveryItemQuery(Common.SalesPurchaseFlags.Sales);
  public importQuery = new Common.DeliveryItemImportQuery('出荷明細',Common.SalesPurchaseFlags.Sales);
  public exportQuery = new Common.DeliveryItemExportQuery('出荷明細',this.params,Common.SalesPurchaseFlags.Sales);
  public invoiceExportQuery = new Common.DeliveryItemExportQuery('請求明細',this.params,Common.SalesPurchaseFlags.Sales,true);
  public usedTypes = Common.UsedTypes;  
  public hasLicenseCurrency: boolean = false;
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'deliveryItemNo', text: '明細番号' },
    { value: 'deliveryDate', text: '出荷日' },
    { value: 'counterpart', text: '得意先' },
    { value: 'warehouse', text: '出庫倉庫' },
    { value: 'commodity', text: '商品' },
    { value: 'invoiceNo', text: '請求書番号' },
    { value: 'bookDate', text: '売上日' },
    { value: 'deliveryNo', text: '出荷番号' },
    { value: 'orderItemNo', text: '受注明細番号' },
    { value: 'specificPurchaseItemNo', text: '入荷明細番号' },
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'commodityName', text: '商品名称' },
    { value: 'salesOrderRefNo', text: '受注管理番号' },
    { value: 'refNo', text: '出荷管理番号' },
    { value: 'customerOrderNo', text: '顧客注文番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true];
  public tenantSettings: Common.TenantSettings = null;
  public voucherTypes = Common.voucherTypes;    
  public visibleTypes = Common.visibleTypes;  
  public dispFlag: number = Common.InputTypes.SalesDelivery;
  public tooltipValue: any;
  @Prop() public deliveryNo:string;
  @Prop() public deliveryItemNo:string;
  @Prop() public orderItemNo:string;
  @Prop() public purchaseDeliveryItemNo:string;
  @Prop() public invoiceNo:string;
  @Prop({default:false}) public isInvoiceItem: boolean;
  @Prop() public commodity:Common.Commodity;
  @Prop() public sku:Common.SKU;  
  @Prop() public state:Common.StockBalanceJournalStatus;    
  @Prop() public deliveryDateTo: Date;
  @Prop() public deliveryDateFrom: Date;
  @Prop() public segment:Common.Segment;  
  @Prop({default:null}) public popup: Components.PopupEditor;    
  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');


  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;

    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    
    // タブ表示の制御
    this.$set(this.tabVisibles, 4, this.$api.useStockFunction); // 予備項目タブ

    // 一覧表示項目の制御
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 150),
      new Common.GridItemConfiguration('明細番号', 150),
      new Common.GridItemConfiguration('出荷日', 100),
      // new Common.GridItemConfiguration('出荷日', 100,this.isInvoiceItem),      
      new Common.GridItemConfiguration('得意先', 180),
      new Common.GridItemConfiguration('商品', 180),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('単位', 100),
      new Common.GridItemConfiguration('出荷数量', 120),
      new Common.GridItemConfiguration('納入区分', 120,this.isInvoiceItem == false),
      new Common.GridItemConfiguration('出庫倉庫', 150,this.isInvoiceItem == false),      
      new Common.GridItemConfiguration('出荷番号', 150,this.isInvoiceItem == false),
      // new Common.GridItemConfiguration('出荷日', 100,this.isInvoiceItem == false),
      new Common.GridItemConfiguration('請求書番号', 150, this.isInvoiceItem),
      new Common.GridItemConfiguration('売上日', 150, this.isInvoiceItem),      
      new Common.GridItemConfiguration('取引通貨', 100,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('単価', 150),
      new Common.GridItemConfiguration('税区分', 150),
      new Common.GridItemConfiguration('出荷番号', 150,this.isInvoiceItem),      
      new Common.GridItemConfiguration('受注明細番号', 150),
      new Common.GridItemConfiguration('入荷明細番号', 150,this.isInvoiceItem == false),
      // new Common.GridItemConfiguration('行番号', 150),
      new Common.GridItemConfiguration('案件', 150),      
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('担当者', 150),
      new Common.GridItemConfiguration('商品名称', 150),
      new Common.GridItemConfiguration('調整数量', 150,this.isInvoiceItem == false),
      new Common.GridItemConfiguration('NCV', 150,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('棚卸対象外', 150,this.isInvoiceItem == false),
      new Common.GridItemConfiguration('取引金額', 150),
      new Common.GridItemConfiguration('税抜金額', 150,this.isInvoiceItem),
      new Common.GridItemConfiguration('計上金額', 150,this.hasLicenseCurrency && this.isInvoiceItem),
      // new Common.GridItemConfiguration('計上税額', 150,this.hasLicenseCurrency),
      // new Common.GridItemConfiguration('備考', 150),
      new Common.GridItemConfiguration('受注管理番号', 150),
      new Common.GridItemConfiguration('出荷管理番号', 150),
      new Common.GridItemConfiguration('顧客注文番号', 150),
      // new Common.GridItemConfiguration('ワークフロー', 150),
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),
    );

    this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,true,true));
    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;
    // インポート・エクスポートの制御
    this.importQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.invoiceExportQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    //クエリ動作をセット(フィルタ動作が異なる)
    this.params.isInvoiceItem  = this.isInvoiceItem;

    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) {
      if (this.isInvoiceItem)this.params.state = Common.StockBalanceJournalStatus.SalesDeliveryInvoiceItem;
      else this.params.state = Common.StockBalanceJournalStatus.SalesDeliveryItem; //出荷済みはステータス表示が異なるので表示しない
    } else {
      if (this.isInvoiceItem)this.params.state = Common.StockBalanceJournalStatus.SalesDeliveryNotCompleted;
      else this.params.state = Common.StockBalanceJournalStatus.SalesDeliveryItem; //出荷明細側は全件表示と未完了は同じ      
    }

    // 検索条件を設定する
    if(this.deliveryNo){
      this.params.deliveryNo = this.deliveryNo;
      this.params.state = null;
    }
    else if(this.orderItemNo){
      this.params.orderItemNo = this.orderItemNo;
      this.params.state = null;
    }
    else if(this.deliveryItemNo) {
      this.params.deliveryItemNo = this.deliveryItemNo;
      this.params.state = null;
    }
    else if(this.purchaseDeliveryItemNo) {
      this.params.purchaseDeliveryItemNo = this.purchaseDeliveryItemNo;
      this.params.state = null;
    }
    else if(this.invoiceNo){
      this.params.invoiceNo = this.invoiceNo;
      this.params.state = null;
    // }
    // // 請求明細用設定
    // else if(this.isInvoiceItem){
    //   this.params.state = Common.StockBalanceJournalStatus.SalesDeliveryNotCompleted;
    //   this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
    }else if (!this.commodity && !this.sku && !this.state && !this.deliveryDateTo){
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    
    // //タスク表示モードの設定(全件/未完了)
    // if (this.$api.onlyOpen == false) {
    //   if (this.isInvoiceItem)this.params.state = Common.StockBalanceJournalStatus.SalesDeliveryInvoiceItem;
    //   else this.params.state = Common.StockBalanceJournalStatus.SalesDeliveryItem; //出荷済みはステータス表示が異なるので表示しない
    // }
    if (this.segment) this.params.segment = this.segment;           
    if (this.commodity)this.params.commodity = this.commodity;
    if (this.sku)this.params.sku = this.sku;
    if (this.state)this.params.state = this.state;       
    if (this.deliveryDateTo)this.params.deliveryDateTo = this.deliveryDateTo;     
    if (this.deliveryDateFrom)this.params.deliveryDateFrom = this.deliveryDateFrom;     
     //ツールチップの文言の設定
    if(this.isInvoiceItem){
      //請求明細
      this.tooltipValue = {
        tab: {
          salesCharge: "",
          outputReceiver: "",
          reserve: ""
        },
        dialog: {
          bookSalesDialog:{
            workflow_aloneInvoice:"請求時に利用できるワークフローを指定します。【フロー区分】が【請求管理(繰越なし)】になっているデータを選択できます。",
            workflow_carryOverInvoice:"請求時に利用できるワークフローを指定します。【フロー区分】が【請求管理(繰越あり)】になっているデータから選択ができます。",
            invoiceTypes:"【請求処理】を行う明細の【得意先】に設定されている【請求区分】が表示されます。",
            isTarget:"取引先に対して個別請求（都度請求）を行う場合にチェックを入れます。",
            bookDate:"選択した明細の出荷日と【得意先】の締日に基づいて､日付が表示されます(売上を計上する日付として扱われます)。個別請求の場合のみ編集が可能です。",
            dueDate:"請求金額の入金予定日です｡処理を行う【得意先】に設定されている締日に対する支払月･支払日が表示されます。個別請求の場合のみ編集が可能です。",
            bankAccount:"入金のある自社口座を選択します。【銀行口座一覧】のデータから選択できます。"
          },
          bulkBookSalesDialog:{
            workflow_aloneInvoice:"請求時に利用できるワークフローを指定します。【フロー区分】が【請求管理(繰越なし)】になっているデータを選択できます。",
            workflow_carryOverInvoice:"請求時に利用できるワークフローを指定します。【フロー区分】が【請求管理(繰越あり)】になっているデータから選択ができます。",
            bankAccount:"入金のある自社口座を選択します。【銀行口座一覧】のデータから選択できます。"
          },
          returnDeliveryDialog:{
            workflowId: "出荷時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【出荷管理】になっているデータから選択ができます。",
            pic:"案件を担当する人を選択します。【ユーザー】に登録されているデータから選択することができます。",
          },
          shippingInstruction: {
            workflowId: "",
            pic: "",
            deliveryRefNo:  "",
            outputReceiverPostalCode: "",
            outputReceiverAddress1: "",
            outputReceiverAddress2: "",
            outputReceiverAddress3: "",
            outputReceiverName:  "",
            outputReceiverPICSection: "",
            outputReceiverPIC: "",
            outputReceiverPICHonorificTitle: "",
            outputReceiverTelNo: "",
            outputReceiverFaxNo: "",
            deliveryInstruction: ""
          },
          chargeAllocation: {
            workflowId: "",
            pic: "",
            chargeDate: "",
            proportionalDivision: "",
            chargeRefNo: ""
          }
        },
          field: {
            deliveryItemNo: "出荷一覧で出荷データを確定する事で自動付与され､紐づく【出荷明細番号】がそのまま【明細番号】になっています。",
            deliveryDate: "【明細番号】に紐づいている出荷データの出荷日が表示されます。",
            counterpart: "",
            deliveryFlag: "",
            warehouse: "",
            commodity: "【出荷明細一覧】から引き継いだ商品が表示されます。",
            sku: "【出荷明細一覧】から引き継いだSKUが表示されます。",
            uom: "【出荷明細一覧】から引き継いだ単位が表示されます。",
            quantity: "【出荷明細一覧】から引き継いだ出荷数量が表示されます。",
            invoiceNo: "【請求処理】を行うと【請求明細】に紐づく【請求書番号】が表示されます。【請求処理】を行っていない明細には表示されません。",
            bookDate:"商品の【出荷日】ではなく売上を計上する日付です。【請求処理】で指定した【売上日】が表示されます。請求処理を行っていない明細には表示されません。",
            unitPrice:"【出荷明細一覧】から引き継いだ単価が表示されます。",
            taxCode:  "【出荷明細一覧】から引き継いだ税区分が表示されます。",
            deliveryNo: "選択した【請求明細】に紐づく【出荷番号】が表示されます。",
            orderItemNo: "選択した【請求明細】に紐づく【受注明細番号】が表示されます。",
            purchaseDeliveryItemNo:  "",
            lastUpdateTime: "請求明細データを最後に更新した日時が表示されています。",
            state :  "請求明細データの現在の状態が表示されています。【業務処理】を行う事で変化します。",
            segment:"【出荷明細一覧】から引き継いだ部門が表示されます。",
            pic:"【出荷明細一覧】から引き継いだ担当者が表示されます。",
            commodityName: "【出荷明細一覧】から引き継いだ商品名称が表示されます。",
            adjustmentQuantity: "",
            noStockFlag: "",
            dealAmountFC:  "【出荷数量×単価】の金額が取引金額として表示されます。",
            amountFC:"【出荷数量×単価】の金額を基に､消費税を抜いた金額が表示されます。消費税は【基本情報】の【税区分】を基準としています。",
            refNo: "受注時に【受注管理番号】を設定した場合に表示されます。",
            deliveryRefNo: "出荷時に【出荷管理番号】を設定した場合に表示されます。",
            customerOrderNo: "【受注一覧】で【顧客注文番号】を設定した場合に表示されます。",
            description: "任意で出荷明細に関する情報を最大200文字まで入力できます。"
          },
        button: {
            updateSeq: "",
            getPrice: "",
            shippingInstruction: "",
            chargeAllocation: "",
            bookSales:"選択した請求明細に対して､請求書番号を発行します。部門や得意先等の明細内容が全て一致する場合は､複数の明細を1つの請求書番号に纏める事ができます。",
            bulkBookSales:"選択した複数の請求明細に対して、一括して請求書番号を発行します。請求書番号は同一内容の明細単位毎に発行されます。",
            returnDelivery:"選択した請求明細に紐づく出荷データについて､返品の伝票を作成します。",
            cancelBookSales:"選択したデータを請求処理がされていない状態に戻すことができます。選択した【請求締待ち】の状態の請求明細に紐づく【請求一覧】上の請求書番号を削除します。"
        }
      }
    }else{
      //出荷明細
      this.tooltipValue = {
        tab: {
          salesCharge: "選択した【出荷明細】に紐づいている【売上諸掛按分明細】を確認できます。",
          outputReceiver: "【納入先】の情報が表示されます。【出荷明細一覧】からは変更できません。",
          reserve: "任意にテキスト入力・区分の設定・日付設定を行えます｡項目名は【テナント設定】＞【商品予備項目】から変更が可能です。内容は帳票に載せることができます。"
        },
        dialog: {
          returnDeliveryDialog:{
            workflowId: "",
            pic:"",
          },          
          shippingInstruction: {
            workflowId: "出荷時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【出荷管理】になっているデータから選択ができます。",
            pic: "案件を担当する人を選択します。【ユーザー】のデータを選択することができます。",
            deliveryRefNo:  "任意で登録する出荷に対して出荷管理番号を入力することができます。",
            outputReceiverPostalCode: "納入先郵便番号を編集できます。初期値は受注データの【納入先郵便番号】になっています。",
            outputReceiverAddress1: "納入先住所1を編集できます。初期値は受注データの【納入先住所1】になっています。",
            outputReceiverAddress2: "納入先住所2を編集できます。初期値は受注データの【納入先住所2】になっています。",
            outputReceiverAddress3: "納入先住所3を編集できます。初期値は受注データの【納入先住所3】になっています。",
            outputReceiverName:  "納入先名称を編集できます。初期値は受注データの【納入先名称】になっています。",
            outputReceiverPICSection: "納入先担当部署名を編集できます。初期値は受注データの【納入先担当部署名】になっています。",
            outputReceiverPIC: "納入先担当者を編集できます。初期値は受注データの【納入先担当者】になっています。",
            outputReceiverPICHonorificTitle: "帳票等に表示する納入先の敬称を編集できます。初期値は受注データの【敬称】になっています。",
            outputReceiverTelNo: "納入先電話番号を編集できます。初期値は受注データの【納入先電話番号】になっています。",
            outputReceiverFaxNo: "納入先FAX番号を編集できます。初期値は受注データの【納入先FAX番号】になっています。",
            deliveryInstruction: "出荷指示を入力できます。入力した値は､出荷一覧の【記載事項】タブに反映されます。"
          },
          chargeAllocation: {
            workflowId: "売上諸掛按分時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【諸掛管理】になっているデータから選択ができます。",
            pic: "案件の担当者を選択します。【ユーザー】に登録されたデータを選択することができます。",
            chargeDate: "売上諸掛が発生した日付を入力します。初期値は登録日当日になっています。",
            proportionalDivision: "諸掛の按分方法を選択します。初期値は数量按分になっています。",
            chargeRefNo: "任意で最大30文字まで諸掛に管理番号を登録することができます。"
          }
        },
        field: {
          deliveryItemNo: "【出荷番号】に紐づく明細番号が自動で付与されます。",
          deliveryDate: "【出荷一覧】で登録した出荷日が表示されます。【出荷明細一覧】からは変更できません。",
          counterpart: "【出荷一覧】で登録した得意先が表示されます。【出荷明細一覧】からは変更できません。",
          deliveryFlag: "出荷する商品を【在庫】とするか、お客様に【直送】するかの区分が表示されます。",
          warehouse: "【出荷一覧】で登録した【出庫倉庫】が表示されます。【出荷明細一覧】からは変更できません。",
          commodity: "【出荷一覧】から登録を行った､または【受注明細一覧】から引き当て処理を行った商品が表示されます。",
          sku: "【商品】に対応したSKUを選択できます。【SKU一覧】より商品にSKUを設定している場合に、選択が可能です。",
          uom: "【商品】に対応した単位が選択可能です。【商品一覧】に登録されている【計上単位】､【荷姿一覧】に登録した単位が表示されます。",
          quantity: "",
          invoiceNo: "",
          bookDate:"",
          deliveryNo: "選択した出荷明細に対応する出荷番号が表示されています。クリックすることで出荷一覧に移動します。",
          unitPrice:"",
          taxCode:  "登録する税区分を選択します。【税区分一覧】のデータを選択できます。",
          orderItemNo: "選択した【出荷明細】に紐づいている【受注明細】が表示されます。",
          purchaseDeliveryItemNo:  "【納入区分】が直送もしくは個別法部門の場合に､選択した【出荷明細】に紐づいている【入荷明細】が表示されます。",
          lastUpdateTime: "出荷データを最後に更新した日時が表示されています。",
          state :  "出荷明細データの現在の状態が表示されており､業務処理や出荷一覧で確定を行う事で変化します。",
          segment:"",
          pic:"",
          commodityName: "受注が紐づいている場合は受注で登録した商品名称が表示され、変更出来ません。それ以外では初期値は任意で変更する事が可能です。",
          adjustmentQuantity: "金額の計上はせずに出荷数量を調整したい場合に数量を入力します。",
          noStockFlag: "【商品】に登録した商品の【棚卸商品区分】の値が表示されます。",
          dealAmountFC:  "取引金額が表示されます。【出荷数量×単価】の計算方法で出力されます。",
          amountFC:"",
          refNo: "受注時に【管理番号】を設定した場合に表示されます。",
          customerOrderNo: "受注時に【顧客注文番号】を設定した場合に表示されます。",
          description: "任意で出荷明細に関する情報を最大200文字まで入力できます。"
        },
        button: {
          updateSeq: "1件の出荷に複数の出荷明細が登録されている場合､明細の順番を変更する事ができます。明細の数が１つしかない場合は変更できません。",
          getPrice: "商品の単価を取得します。単価の取得基準は【商品一覧】の【販売単価区分】で登録をします。",
          shippingInstruction: "状態が【出荷指示待ち】になっている【出荷明細】から【出荷番号】を作成する処理を行います。（【出荷一覧】から【出荷明細】を作成した場合は不要）",
          chargeAllocation: "選択した出荷明細に対して諸掛の按分登録を行います。"
        }
      }
    }
    this.$api.formatter.ensureListLoaded('workflow_aloneInvoice');
    this.$api.formatter.ensureListLoaded('workflow_carryOverInvoice');
    this.$api.formatter.ensureListLoaded('workflow_charge');
  }

  public async onCreate(obj: Common.SalesDeliveryItem) {
    // const workflows = this.$api.formatter.getOptions('workflow_salesDeliveryItem');
    // if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  // 画面のリフレッシュ(再描画)
  public refreshListView(){
    var page = (this.$refs.mainList as Components.ListView).currentPage;
    (this.$refs.mainList as Components.ListView).onPageChange(page);
  }

  // 商品変更時に商品名・予備項目を設定する
  public onChangeCommodity(item:Common.DeliveryItem){
    item.onChangeCommodity(this.tenantSettings);
  }

  // 単価・税区分を取得する
  public getPriceAndTaxCode(item:Common.SalesDeliveryItem){
    this.$api.execute(new Common.DeliveryGetItemPriceQuery(item.delivery, item)).then(res => {
      item.unitPrice = res.unitPrice;
      item.taxCode = res.taxCode;
    });
  }

  //個別法入力時に編集可
  public isEditableSpecificPricing(item:Common.SalesDeliveryItem){
    if (item.segment.priceCalculationMethod == Common.PricingTypes.Specific && item.state == Common.StockBalanceJournalStatus.SalesDeliveryInstructionWaiting)return true;
    else return false;
  }

  //直接以外の場合編集可
  public isEditableStock(item:Common.SalesDeliveryItem){
      //直接以外の場合に編集可
      if (item.deliveryFlag != Common.DeliveryFlags.Direct) {
         if(item.state == Common.StockBalanceJournalStatus.SalesDeliveryInstructionWaiting) return true;
         if(item.state == Common.StockBalanceJournalStatus.SalesDelivering) return true;   
      }    
      return false;  
  }
  //在庫出荷時に編集可(出荷日)
  public isEditableStockDeliveryDate(item:Common.SalesDeliveryItem){
      //直接入力&在庫出荷の場合に編集可
      if (item.deliveryFlag == Common.DeliveryFlags.Stock) {
         if(item.state == Common.StockBalanceJournalStatus.SalesDeliveryInstructionWaiting) return true;
        //  if(item.state == Common.StockBalanceJournalStatus.SalesDelivering) return true;   
      }    
      return false;  
  }
  //結果入力(受注非継承時)に編集可
  public isEditableResult(item:Common.SalesDeliveryItem, editNoComplete:boolean = false){
      //直接入力&在庫出荷の場合に編集可
      if (item.orderItem == null) {
         if(item.state == Common.StockBalanceJournalStatus.SalesDeliveryInstructionWaiting) return true;
         if(item.state == Common.StockBalanceJournalStatus.SalesDelivering) return true;   
         if(editNoComplete == true && item.state != Common.StockBalanceJournalStatus.SalesDeliveryCompleted) return true
      }    
      return false;  
  }
  // 状態から編集可能か判別する
  public isEditable(item:Common.SalesDeliveryItem, shouldCheckOrderItem:boolean, shouldCheckDirect:boolean, shouldCheckDelivering:boolean, shouldCheckSegment:boolean):boolean{
    //個別法は別途処理
    // if(shouldCheckSegment && item.segment != null && item.segment.priceCalculationMethod == Common.PricingTypes.Specific) return true;
    if(shouldCheckOrderItem && item.orderItem != null) return false;
    if(shouldCheckDirect && item.delivery != null && item.delivery.deliveryFlag == Common.DeliveryFlags.Direct) return false;
    if(item.state == Common.StockBalanceJournalStatus.SalesDeliveryInstructionWaiting) return true;
    if(shouldCheckDelivering && item.state == Common.StockBalanceJournalStatus.SalesDelivering) return true;
    return false;
  }
  
  public isPriceEditable(item:Common.SalesDeliveryItem){
    if(item.orderItem != null && (this.$api.tenantSettings as Common.TenantSettings).salesDeliveryPriceChangeFlag == false) return false;
    if(item.state != Common.StockBalanceJournalStatus.SalesDeliveryCompleted) return true;
    return false;
  }



  public isEditableScheduleDeliveryDate(item:Common.SalesDeliveryItem): boolean{
    if(item.orderItemId != null){
      // 受注明細継承時、および納入区分＝直送時は常に非活性
      if(item.deliveryFlag == Common.DeliveryFlags.Direct) return false;
      // 受注明細継承時、および納入区分＝ブランク(在庫)かつ ステータス=DeliveryInstructionWaitingの場合 活性
    if(item.state == Common.StockBalanceJournalStatus.SalesDeliveryInstructionWaiting) return true;
    }
    // 受注明細非継承時、ステータス=DeliveryInstructionWaitingの場合 活性、以外 非活性
    else if(item.state == Common.StockBalanceJournalStatus.SalesDeliveryInstructionWaiting){
      return true;
    }
    return false;
  }
  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.SalesDeliveryItem){
    //親を変更する(受注=>出荷=>請求)
    if(item.invoiceNo) this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.SalesInvoice, sourceNo : item.invoiceNo, isItem: true},this.$el);  //請求明細
    else if (item.deliveryNo)  this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.SalesDelivery, sourceNo : item.deliveryNo, isItem: true},this.$el); //出荷明細
    else  this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.SalesOrder, sourceNo : item.orderNo, isItem: true},this.$el); //出荷指示待ち明細
  }

  // 出荷一覧へ遷移する
  public showSalesDelivery() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.DeliveryItem;
    if(obj.delivery) this.$router.push(String.format('/sales/SalesDelivery?deliveryNo={0}', obj.delivery.deliveryNo));
  }

  public getInvoiceLinkFormat(item : Common.DeliveryItem){
    if(!item.invoiceNo) return '';
    if(item.delivery.counterpart.invoiceType != Common.InvoiceTypes.ConsolidateInvoiceCarryOver) return '/sales/AloneInvoice?invoiceNo={0}';
    else if(item.invoiceNo.indexOf(item.deliveryNo) >= 0) return '/sales/AloneInvoice?invoiceNo={0}';
    else return '/sales/CarryOverInvoice?invoiceNo={0}';
  }
  // 繰越請求一覧・請求一覧へ遷移する
  public showInvoice(item: Common.DeliveryItem) {
    if(!item.invoiceNo) return;
    if(item.delivery.counterpart.invoiceType != Common.InvoiceTypes.ConsolidateInvoiceCarryOver)
      this.$router.push(String.format('/sales/AloneInvoice?invoiceNo={0}', item.invoiceNo));
    else if(item.invoiceNo.indexOf(item.deliveryNo) >= 0)
      this.$router.push(String.format('/sales/AloneInvoice?invoiceNo={0}', item.invoiceNo));
    else
      this.$router.push(String.format('/sales/CarryOverInvoice?invoiceNo={0}', item.invoiceNo));
  }

  // 受注明細一覧へ遷移する
  public showSalesOrderItem(itemNo: string, editor: Components.Editor){
    if(itemNo && editor.isEdit == false) this.$router.push(String.format('/sales/SalesOrderItem?orderItemNo={0}',itemNo));
  }

  // 入荷明細一覧へ遷移する
  public showPurchaseDeliveryItem(itemNo: string, editor: Components.Editor){
    if(itemNo && editor.isEdit == false) this.$router.push(String.format('/purchase/PurchaseDeliveryItem?deliveryItemNo={0}',itemNo));
  }

  // 一覧でチェックされている出荷明細
  public checkedDeliveryItems: Array<Common.DeliveryItem>= new Array(0);
  public getCheckedDeliveryItems(){
    this.checkedDeliveryItems = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        this.checkedDeliveryItems.push(obj);
      }
    });
  }

  // 出荷指示用プロパティ
  public siWorkflowId: number = null;
  public siPic: string = '';
  public siRefNo: string = '';
  public siDeliveryDate: Date = new Date().getCalendarDate();
  public siCounterpart: Common.Counterpart = null;
  public siReceiver: Common.Counterpart = null;
  public siReceiverPostalCode: string = '';
  public siReceiverAddress1: string = '';
  public siReceiverAddress2: string = '';
  public siReceiverAddress3: string = '';
  public siReceiverName: string = '';
  public siReceiverPICSection: string = '';
  public siReceiverPIC: string = '';
  public siReceiverPICHonorificTitle: string = '';
  public siReceiverTelNo: string = '';
  public siReceiverFaxNo: string = '';
  public siDeliveryInstruction: string = '';
  public siWorkflowRequired: boolean = false;

  // 出荷指示ワークフロー処理用プロパティ
  public siButtonNames: Array<string> = null;
  public siButtonIndexIdArray: Array<{index:number,actionId:number}> =null;
  // 出荷指示ダイアログを表示する
  public showShippingInstructionDialog() {
    this.getCheckedDeliveryItems();

    // ダイアログ表示前バリデーション
    if(this.checkedDeliveryItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);      
      return;
    }
    if(this.checkedDeliveryItems.filter(item => item.state != Common.StockBalanceJournalStatus.SalesDeliveryInstructionWaiting).length > 0){
      this.$api.modal.show('', '出荷指示待ちの明細を選択して下さい。', true, null);
      return;
    }
    if(this.checkedDeliveryItems.filter(item => this.checkedDeliveryItems[0].segment.id != item.segment.id).length > 0){
      this.$api.modal.show('', '部門の異なる出荷明細を、同じ出荷伝票にまとめることはできません。', true, null);
      return;
    }
    var firstOrderItem = this.checkedDeliveryItems[0].orderItem;
    if(this.checkedDeliveryItems.filter(item => ((firstOrderItem ? firstOrderItem.order.counterpartId : 0) != (item.orderItem ? item.orderItem.order.counterpartId : 0))).length > 0){
      this.$api.modal.show('', '得意先の異なる出荷明細を、同じ出荷伝票にまとめることはできません。', true, null);
      return;
    }
    // if(this.checkedDeliveryItems.filter(item => this.checkedDeliveryItems[0].warehouseId != item.warehouseId).length > 0){
    //   this.$api.modal.show('', '倉庫の異なる出荷明細を、同じ出荷伝票にまとめることはできません。', true, null);
    //   return;
    // }

    //棚卸対象外商品(倉庫未設定)を許容する
    if(new Set(this.checkedDeliveryItems.filter(item => item.warehouseId != null).map(item=>item.warehouseId)).keys.length > 0){
      this.$api.modal.show('', '倉庫の異なる出荷明細を、同じ出荷伝票にまとめることはできません。', true, null);
      return;
    }
    // 警告メッセージ表示
    if(this.checkedDeliveryItems.filter(item => ((firstOrderItem ? firstOrderItem.order.outputReceiverPostalCode : '') != (item.orderItem ? item.orderItem.order.outputReceiverPostalCode : ''))).length > 0){
      this.$api.modal.show('', '納入先詳細(郵便番号)の異なる出荷明細が選択されています。出荷指示を続行した場合、入力値で上書きされます。', true, null);
    }
    else if(this.checkedDeliveryItems.filter(item => ((firstOrderItem ? firstOrderItem.order.outputReceiverAddress1 : '') != (item.orderItem ? item.orderItem.order.outputReceiverAddress1 : ''))).length > 0){
      this.$api.modal.show('', '納入先詳細(住所1)の異なる出荷明細が選択されています。出荷指示を続行した場合、入力値で上書きされます。', true, null);
    }
    else if(this.checkedDeliveryItems.filter(item => ((firstOrderItem ? firstOrderItem.order.outputReceiverAddress2 : '') != (item.orderItem ? item.orderItem.order.outputReceiverAddress2 : ''))).length > 0){
      this.$api.modal.show('', '納入先詳細(住所2)の異なる出荷明細が選択されています。出荷指示を続行した場合、入力値で上書きされます。', true, null);
    }
    else if(this.checkedDeliveryItems.filter(item => ((firstOrderItem ? firstOrderItem.order.outputReceiverAddress3 : '') != (item.orderItem ? item.orderItem.order.outputReceiverAddress3 : ''))).length > 0){
      this.$api.modal.show('', '納入先詳細(住所3)の異なる出荷明細が選択されています。出荷指示を続行した場合、入力値で上書きされます。', true, null);
    }
    else if(this.checkedDeliveryItems.filter(item => ((firstOrderItem ? firstOrderItem.order.outputReceiverName : '') != (item.orderItem ? item.orderItem.order.outputReceiverName : ''))).length > 0){
      this.$api.modal.show('', '納入先詳細(名称)の異なる出荷明細が選択されています。出荷指示を続行した場合、入力値で上書きされます。', true, null);
    }
    else if(this.checkedDeliveryItems.filter(item => ((firstOrderItem ? firstOrderItem.order.outputReceiverPICSection : '') != (item.orderItem ? item.orderItem.order.outputReceiverPICSection : ''))).length > 0){
      this.$api.modal.show('', '納入先詳細(担当部署名)の異なる出荷明細が選択されています。出荷指示を続行した場合、入力値で上書きされます。', true, null);
    }
    else if(this.checkedDeliveryItems.filter(item => ((firstOrderItem ? firstOrderItem.order.outputReceiverPIC : '') != (item.orderItem ? item.orderItem.order.outputReceiverPIC : ''))).length > 0){
      this.$api.modal.show('', '納入先詳細(担当者)の異なる出荷明細が選択されています。出荷指示を続行した場合、入力値で上書きされます。', true, null);
    }
    else if(this.checkedDeliveryItems.filter(item => ((firstOrderItem ? firstOrderItem.order.outputReceiverPICHonorificTitle : '') != (item.orderItem ? item.orderItem.order.outputReceiverPICHonorificTitle : ''))).length > 0){
      this.$api.modal.show('', '納入先詳細(敬称)の異なる出荷明細が選択されています。出荷指示を続行した場合、入力値で上書きされます。', true, null);
    }
    else if(this.checkedDeliveryItems.filter(item => ((firstOrderItem ? firstOrderItem.order.outputReceiverTelNo : '') != (item.orderItem ? item.orderItem.order.outputReceiverTelNo : ''))).length > 0){
      this.$api.modal.show('', '納入先詳細(電話番号)の異なる出荷明細が選択されています。出荷指示を続行した場合、入力値で上書きされます。', true, null);
    }
    else if(this.checkedDeliveryItems.filter(item => ((firstOrderItem ? firstOrderItem.order.outputReceiverFaxNo : '') != (item.orderItem ? item.orderItem.order.outputReceiverFaxNo : ''))).length > 0){
      this.$api.modal.show('', '納入先詳細(FAX番号)の異なる出荷明細が選択されています。出荷指示を続行した場合、入力値で上書きされます。', true, null);
    }

    // プロパティの初期化
    var workflows = this.$api.formatter.getOptions('workflow_salesDelivery');
    this.siWorkflowId = workflows.length > 0 ?  workflows[0].value : 0;
    this.onChangeWorkflowShippingInstruction();
    this.siPic = (firstOrderItem.order && firstOrderItem.order.counterpart.salesPerson) ? firstOrderItem.order.counterpart.salesPerson : this.$api.auth.userId;
    this.siRefNo = '';
    this.siDeliveryDate = 
      this.checkedDeliveryItems.filter(obj => obj.deliveryDate != null).length == 0 ? new Date().getCalendarDate() :
      this.checkedDeliveryItems
      .filter(obj => obj.deliveryDate != null)
      .map(obj => obj.deliveryDate)
      .reduce((max, value) => max = max > value ? max : value);
    this.siCounterpart = firstOrderItem ? firstOrderItem.order.counterpart : null;
    this.siReceiverPostalCode = firstOrderItem ? firstOrderItem.order.outputReceiverPostalCode : '';
    this.siReceiverAddress1 = firstOrderItem ? firstOrderItem.order.outputReceiverAddress1 : '';
    this.siReceiverAddress2 = firstOrderItem ? firstOrderItem.order.outputReceiverAddress2 : '';
    this.siReceiverAddress3 = firstOrderItem ? firstOrderItem.order.outputReceiverAddress3 : '';
    this.siReceiverName = firstOrderItem ? firstOrderItem.order.outputReceiverName : '';
    this.siReceiverPICSection = firstOrderItem ? firstOrderItem.order.outputReceiverPICSection : '';
    this.siReceiverPIC = firstOrderItem ? firstOrderItem.order.outputReceiverPIC : '';
    this.siReceiverPICHonorificTitle = firstOrderItem ? firstOrderItem.order.outputReceiverPICHonorificTitle : '';
    this.siReceiverTelNo = firstOrderItem ? firstOrderItem.order.outputReceiverTelNo : '';
    this.siReceiverFaxNo = firstOrderItem ? firstOrderItem.order.outputReceiverFaxNo : '';
    this.siWorkflowRequired = workflows.length > 0;
    // 出荷指示引継
    var orders:Array<Common.Order>= new Array(0);
    this.checkedDeliveryItems.forEach(item =>{
      if(orders.filter(obj => obj.orderNo == item.orderNo).length == 0) orders.push(item.orderItem.order);
    });
    this.siDeliveryInstruction = (orders.map(obj => obj.deliveryInstruction)).join('\r\n');

    // 納入先をロードしてダイアログを表示する
    this.siReceiver = null;
    if(firstOrderItem.order.receiverId) this.$api.find('Counterpart', [firstOrderItem.order.receiverId]).then(res => this.siReceiver = res);
    
    // ダイアログの表示
    (this.$refs.shippingInstructionDialog as Components.ListDialog).showDialog();
  }

  // 出荷指示の納入先変更
  public onChangeSiReceiver(){
    this.siReceiverPostalCode = this.siReceiver.postalCode;
    this.siReceiverAddress1 = this.siReceiver.address1;
    this.siReceiverAddress2 = this.siReceiver.address2;
    this.siReceiverAddress3 = this.siReceiver.address3;
    this.siReceiverName = this.siReceiver.name;
    this.siReceiverPICSection = this.siReceiver.picSection;
    this.siReceiverPIC = this.siReceiver.pic;
    this.siReceiverPICHonorificTitle = this.siReceiver.honorificTitle;
    this.siReceiverTelNo = this.siReceiver.telNo;
    this.siReceiverFaxNo = this.siReceiver.faxNo;
  }

  // 出荷指示の実行
  public async submitShippingInstruction(items:any[], index:number) {
    // クエリの設定
    this.getCheckedDeliveryItems();
    var query = new Common.ShippingInstructionsQuery();
    query.deliveryItems = this.checkedDeliveryItems;
    query.workflowId = this.siWorkflowId ? this.siWorkflowId : 0;
    query.actionId = this.siButtonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
    query.pic = this.siPic;
    query.refNo = this.siRefNo;
    query.deliveryDate = this.siDeliveryDate;
    query.receiver = this.siReceiver;
    query.outputReceiverPostalCode = this.siReceiverPostalCode;
    query.outputReceiverAddress1 = this.siReceiverAddress1;
    query.outputReceiverAddress2 = this.siReceiverAddress2;
    query.outputReceiverAddress3 = this.siReceiverAddress3;
    query.outputReceiverName = this.siReceiverName;
    query.outputReceiverPICSection = this.siReceiverPICSection;
    query.outputReceiverPIC = this.siReceiverPIC;
    query.outputReceiverPICHonorificTitle = this.siReceiverPICHonorificTitle;
    query.outputReceiverTelNo = this.siReceiverTelNo;
    query.outputReceiverFaxNo = this.siReceiverFaxNo;
    query.deliveryInstruction = this.siDeliveryInstruction;

    // 出荷指示の実行
    // await this.$api.execute(query)
    // .finally(()=>{
    //   this.refreshListView();
    // });

    return this.$api.execute(query,true).then(res => {
      //リスト更新
      (this.$refs.mainList as Components.ListView).reload();
      var deliveries = res as Common.Delivery[];
      var links = deliveries.map(delivery=>new Common.ModalLink(delivery.deliveryNo,String.format('/sales/SalesDelivery?deliveryNo={0}',delivery.deliveryNo)));
      //this.$api.modal.show('処理結果','以下の出荷伝票が作成されました。',true,null,links);
      this.$api.modal.show('処理結果','以下の出荷伝票が作成されました。',false,()=>this.$router.push(String.format('/sales/SalesDelivery?deliveryNo={0}',deliveries[0].deliveryNo)),links,'伝票に移動する','閉じる');      
      return true;
    }).catch(()=>{return false;});          
  }
  public onChangeWorkflowShippingInstruction(){
    this.siButtonNames=new Array();
    this.siButtonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.siButtonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.siButtonNames.push("出荷保存");
    if(this.siWorkflowId!=0)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('salesDelivery', this.siWorkflowId, Common.DeliveryStatus.SalesDeliveryPostWaiting);
      actions.forEach(action => {
        this.siButtonNames.push(action.actionName);
        this.siButtonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }
  }

  // // 返品ダイアログ用プロパティ
  // public rdCaptions = new Array();
  // public rdWidths = new Array();
  // public rdSlots = new Array();
  // public rdGridConfig:Common.GridConfiguration = null;
  // public rdPic: string = '';
  // public rdReturnDate: Date = new Date().getCalendarDate();
  // public rdWorkflowId:number = 0;
  // // ワークフロー処理用プロパティ
  // public rdButtonNames: Array<string> = null;
  // public rdButtonIndexIdArray: Array<{index:number,actionId:number}> =null;

  // // 返品処理ダイアログを表示
  public showReturnDeliveryDialog() {
    this.getCheckedDeliveryItems();

    let componentClass = Vue.extend(this.returnDelivery);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          checkedDeliveryItems: this.checkedDeliveryItems,
          salesPurchaseFlag: Common.SalesPurchaseFlags.Sales,
          parentMainList: this.$refs.mainList,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);

  //   // ダイアログ表示前バリデーション
  //   if(this.checkedDeliveryItems.length == 0){
  //     this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);      
  //     return;
  //   }
  //   if(this.checkedDeliveryItems.filter(item => item.quantity < 0).length > 0){
  //     this.$api.modal.show('', '返品の請求明細が選択されています。', true, null);
  //     return;
  //   }
  //   if(this.checkedDeliveryItems.filter(item => item.segment.id != this.checkedDeliveryItems[0].segment.id).length > 0){
  //     this.$api.modal.show('', '部門の異なる請求明細を、同じ返品伝票にまとめることはできません。', true, null);
  //     return;
  //   }
  //   if(this.checkedDeliveryItems.filter(item => item.delivery.counterpart.id != this.checkedDeliveryItems[0].delivery.counterpart.id).length > 0){
  //     this.$api.modal.show('', '得意先の異なる請求明細を、同じ返品伝票にまとめることはできません。', true, null);
  //     return;
  //   }
  //   if(this.checkedDeliveryItems.filter(item => item.warehouseId != this.checkedDeliveryItems[0].warehouseId).length > 0){
  //     this.$api.modal.show('', '倉庫の異なる請求明細を、同じ返品伝票にまとめることはできません。', true, null);
  //     return;
  //   }

  //   // 明細の予備項目表示の可変対応
  //   this.rdGridConfig = new Common.GridConfiguration([],0, 'col');
  //   this.rdGridConfig.setGridItems(
  //     new Common.GridItemConfiguration('商品', 150),
  //     new Common.GridItemConfiguration('SKU', 150),
  //     new Common.GridItemConfiguration('返品数量', 150),
  //     new Common.GridItemConfiguration('調整数量', 150)
  //   );
  //   this.rdGridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,false));
  //   this.rdCaptions =this.rdGridConfig.gridCaptions;
  //   this.rdWidths = this.rdGridConfig.gridWidths;
  //   this.rdSlots = this.rdGridConfig.gridSlots;
  //   this.rdWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_salesDelivery');
  //   this.onReturnDeliveryChangeWorkflow();

  //   // プロパティの初期化
  //   this.rdPic = this.checkedDeliveryItems[0].delivery.counterpart.salesPerson ? this.checkedDeliveryItems[0].delivery.counterpart.salesPerson : this.$api.auth.userId;
  //   this.rdReturnDate = new Date().getCalendarDate();

  //   // ダイアログの表示
  //   var items = this.checkedDeliveryItems.map(item => (item as Common.SalesDeliveryItem).copyReturn());
  //   (this.$refs.returnDeliveryDialog as Components.ListDialog).items = items;
  //   (this.$refs.returnDeliveryDialog as Components.ListDialog).showDialog();
  // }

  // public onReturnDeliveryChangeWorkflow(){
  //   this.rdButtonNames=new Array();
  //   this.rdButtonIndexIdArray = new Array();
  //   var buttonIndex = 0;
  //   this.rdButtonIndexIdArray.push({index:buttonIndex++,actionId:0})
  //   this.rdButtonNames.push("出荷保存");
  //   if(this.rdWorkflowId!=0)
  //   {
  //     var actions = this.$api.perms.getWorkflowActionsHasPermission('salesDelivery', this.rdWorkflowId, Common.DeliveryStatus.SalesDeliveryPostWaiting);
  //     actions.forEach(action => {
  //       this.rdButtonNames.push(action.actionName);
  //       this.rdButtonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
  //     });
  //   }

  // }

  // // 返品処理の実行
  // public async submitReturnDelivery(list: Array<Common.DeliveryItem>, index:number) {
  //  // クエリの設定
  //   var query = new Common.ReturnDeliveryQuery();
  //   query.pic = this.rdPic;
  //   query.deliveryDate = this.rdReturnDate;
  //   query.workflowId = this.rdWorkflowId;
  //   query.deliveryItems = new Array();
  //   query.baseItems = this.checkedDeliveryItems;
  //   query.actionId = this.rdButtonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
  //   list.forEach(item =>{
  //     var returnItem = (item as Common.SalesDeliveryItem).copyReturn();
  //     returnItem.quantity *= -1;
  //     returnItem.adjustmentQuantity *= -1;
  //     query.deliveryItems.push(returnItem);
  //   });

  //   // 返品処理の実行
  //   // this.$api.execute(query)
  //   // .finally(()=>{
  //   //   this.refreshListView();
  //   // });

  //   return this.$api.execute(query,true).then(res => {
  //     //何も更新されないが..
  //      (this.$refs.mainList as Components.ListView).reload();
  //     var returnDelivery = res as Common.Delivery;
  //     this.$api.modal.show('処理結果','以下の出荷伝票が作成されました。',true,null,[new Common.ModalLink(returnDelivery.deliveryNo, String.format('/sales/SalesDelivery?deliveryNo={0}',returnDelivery.deliveryNo))]);
  //     return true;
  //   }).catch(()=>{return false;});    

  }

  // 請求処理ダイアログの表示
  public async showBookSalesDialog() {
    this.getCheckedDeliveryItems();

    let componentClass = Vue.extend(this.bookSales);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          execDelivery: false,
          checkedDeliveryItems: this.checkedDeliveryItems,
          parentMainList: this.$refs.mainList,
          parent: this,
          isItemFlag: true,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }

  // 一括請求処理ダイアログの表示
  public showBulkBookSalesDialog() {
    this.getCheckedDeliveryItems();

    let componentClass = Vue.extend(this.bulkBookSales);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          checkedDeliveryItems: this.checkedDeliveryItems,
          parentMainList: this.$refs.mainList,
          parent: this,
          isItemFlag: true,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);

  }

   // 請求取消処理ダイアログの表示
  public showCancelBookSalesDialog() {
    this.getCheckedDeliveryItems();

    let componentClass = Vue.extend(this.cancelBookSales);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          checkedDeliveryItems: this.checkedDeliveryItems,
          parentMainList: this.$refs.mainList,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  //   // ダイアログ表示前バリデーション
  //   if(this.checkedDeliveryItems.length == 0){
  //     this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);      
  //     return;
  //   }
  //   if(this.checkedDeliveryItems.filter(item => item.state != Common.StockBalanceJournalStatus.SalesDeliveryClosingWaiting).length > 0){
  //     this.$api.modal.show('', '請求締待ちの明細のみを選択して下さい。', true, null);
  //     return;
  //   }

  //   // ダイアログの表示
  //   (this.$refs.cancelBookSalesDialog as Components.ListDialog).showDialog();
  }

  // // 請求取消処理の実行
  // public async submitCancelBookSales() {
  //   this.getCheckedDeliveryItems();

  //   // 実行前バリデーション
  //   if(this.checkedDeliveryItems.length == 0){
  //     return;
  //   }
  //   // this.$api.startWaitCusor();

  //   // クエリの設定
  //   var query = new Common.CancelBookSalesQuery();
  //   query.deliveryItems = this.checkedDeliveryItems;

  //   // 請求取消処理の実行
  //   // await this.$api.execute(query)
  //   // .finally(()=>{
  //   //   this.$api.closeWaitCursor();
  //   //   this.refreshListView();
  //   // });
  //   return this.$api.execute(query,true).then(()=>{ 
  //     (this.$refs.mainList as Components.ListView).reload();
  //     this.$api.modal.show('処理結果','請求取消処理が完了しました。',true,null);
  //     return true;        
  //     }).catch(()=>false);     
  // }

  //諸掛按分処理
  //諸掛按分処理用プロパティ
  public caConfig:Common.GridConfiguration = new Common.GridConfiguration([],0,'col');
  public caPic: string = '';
  public caBookDate: Date = new Date().getCalendarDate();
  public caCurrencyCode: string='';
  public caProportionalDivision: Common.ProportionalDivisionFlags = Common.ProportionalDivisionFlags.ByQuantity;
  public caExchangeRate:number = 0;
  public caRefNo : string = '';
  public caWorkflowId: number = 0;
  public caItems : Common.PurchaseCharge[] = [];
  public caDecimal : number = 0;
  // ワークフロー処理用プロパティ
  public caButtonNames: Array<string> = null;
  public caButtonIndexIdArray: Array<{index:number,actionId:number}> =null;

  // 返品処理ダイアログを表示
  public showChargeAllocationDialog() {
    this.getCheckedDeliveryItems();

    // ダイアログ表示前バリデーション
    if(this.checkedDeliveryItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);      
      return;
    }
    if(this.checkedDeliveryItems.filter(item => item.state == Common.StockBalanceJournalStatus.SalesDeliveryInstructionWaiting ||  item.state == Common.StockBalanceJournalStatus.SalesDelivering).length > 0){
      this.$api.modal.show('', '出荷指示・出荷待ちの明細は選択できません。', true, null);
      return;
    }
    if(this.checkedDeliveryItems.filter(item => item.segment.id != this.checkedDeliveryItems[0].segment.id).length > 0){
      this.$api.modal.show('', '部門の異なる出荷明細を、同じ諸掛伝票にまとめることはできません。', true, null);
      return;
    }

    this.caConfig = new Common.GridConfiguration([],0,'col');
    this.caConfig.setGridItems(
      new Common.GridItemConfiguration('諸掛取引先', 150),
      new Common.GridItemConfiguration('勘定科目', 150),
      new Common.GridItemConfiguration('取引金額', 150),
      new Common.GridItemConfiguration('税区分', 150),
      new Common.GridItemConfiguration('支払予定日', 150),      
    );

    // プロパティの初期化
    this.caPic = this.$api.auth.userId;
    this.caBookDate = new Date().getCalendarDate();
    this.caCurrencyCode = (this.$api.tenantSettings as Common.TenantSettings).currencyCode;
    this.caExchangeRate = 1;
    this.caWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_charge');
    this.onChargeAllocationChangeWorkflow();

    // ダイアログの表示
    // var items = this.checkedDeliveryItems.map(item => item.copy());
    this.caItems = new Array();
    this.caItems.push(new Common.SalesCharge());
    (this.$refs.chargeAllocationDialog as Components.ListDialog).items = this.caItems;
    (this.$refs.chargeAllocationDialog as Components.ListDialog).showDialog();
  }
  public onChargeAllocationChangeWorkflow(){
    this.caButtonNames=new Array();
    this.caButtonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.caButtonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.caButtonNames.push("諸掛保存");
    if(this.caWorkflowId!=0)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('charge', this.caWorkflowId, Common.ChargeStatus.ChargeSaving);
      actions.forEach(action => {
        this.caButtonNames.push(action.actionName);
        this.caButtonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }
  }

  // 取引先変更時に取引先の税区分・支払予定日を設定する
  public onChangeCounterpart(item: Common.Charge){
    item.taxCode = item.counterpart ? item.counterpart.taxCode : '';
    if(item.counterpart == null) item.dueDate = null;
    else  item.dueDate = item.counterpart.getClosingDate(this.caBookDate, this.tenantSettings);    
  }

  // 発生日変更時に支払予定日を設定する
  public onChangeChargeDate(){
    this.caItems.forEach(item =>{
      if(item.counterpart == null) item.dueDate = null;
      else  item.dueDate = item.counterpart.getClosingDate(this.caBookDate, this.tenantSettings);
    });
    this.onChangeCurrency();
  }

  // 発生日・通貨が変更された場合、計上レートを取得する
  public async onChangeCurrency(){
    const query = new Common.GetExchangeRateQuery();
    query.currency = this.caCurrencyCode;
    query.startDate = this.caBookDate;
    let rate = 1;
    await this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      this.caExchangeRate = exchangeRate ? exchangeRate.rate : 1;
    });

    const obj = this.$api.currencies.filter(obj => obj.value == this.caCurrencyCode); 
    if (obj.length == 0) this.caDecimal = 0;
    else this.caDecimal = Number(obj[0].text);
  }

   public async submitChargeAllocation(list: Array<Common.SalesCharge>, index:number){

    if (this.caItems.length == 0){
        this.$api.closeWaitCursor();
        return this.$api.modal.showDialog('無効な操作','諸掛を入力してください。').then(()=>{return false;});
    }    
    
    //ヘッダプロパティの設定
    this.caItems.forEach(charge =>{
      charge.currencyCode = this.caCurrencyCode;
      charge.exchangeRate = this.caExchangeRate;
      charge.proportionalDivision = this.caProportionalDivision;
      charge.workflowId = this.caWorkflowId;
      charge.chargeDate = this.caBookDate;
      charge.pic = this.caPic;
      charge.refNo = this.caRefNo;      
      charge.chargeFlag = Common.SalesPurchaseFlags.Sales; //売上諸掛
      charge.segment = this.checkedDeliveryItems[0].segment;
      charge.target = Common.ChargeItemTypes.Sales;      
    });

    // クエリの設定
    var query = new Common.AddChargeAllocationQuery();
    query.charges = this.caItems; //諸掛のセット
    query.deliveryItems = this.checkedDeliveryItems; //按分対象のセット
    query.actionId = this.caButtonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
    
    // 諸掛按分明細追加の実行
    return this.$api.execute(query,true).then(res => {
      //ダイアログ表示
      var charges = res as Common.SalesCharge[];
      var links = charges.map(charge=>new Common.ModalLink(charge.chargeNo,String.format('/sales/SalesCharge?chargeNo={0}',charge.chargeNo)));
      // this.$api.modal.show('処理結果','以下の諸掛伝票が作成されました。',true,null,links);
      this.$api.modal.show('処理結果','以下の諸掛伝票が作成されました。',true,()=>this.$router.push(String.format('/sales/SalesCharge?chargeNo={0}',charges[0].chargeNo)),links,'伝票に移動する','閉じる');            
      return true;
    }).catch(()=>{return false;});           
   }  
  //検索予備項目
  public isSearchVisible(usedType: Common.UsedTypes){
      return usedType != Common.UsedTypes.None ;
  }       
  public get searchTabs() : string[]{
    return this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText1) || 
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText2) || 
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText3) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText4) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText5) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText6) ||                
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo3) ||                         
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate3) ||            
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList3) 
              ? ['検索条件','予備項目']: ['検索条件'];
  }  
}
</script>

<style lang="scss">
.sales_delivery_item{
  .modal-dialog {
    min-width: 350px;
  }
  .cx_itembutton {
    font-size: 14px;
    height: 28px;
    padding: 2px 7px;
    outline: 0 !important;
    box-shadow: none;
    margin: -3px 10px 10px 0px;
    // min-width:120px;
  }
  .cx_link{
    .cx_textbox_read{
      font-weight: bolder;
      text-decoration: underline;
      cursor: pointer;
      &:hover {
        color: #3194ff !important; 
      }
    }
  }
}
</style>